
export const ADDTAB='ADDTAB';
export const DELTAB='DELTAB';
export const LOADING_INDICATOR = 'LOADING_INDICATOR';
export const UPLOAD_DATA = 'UPLOAD_DATA';
export const CLEAR_TAB='CLEAR_TAB';

